import React, { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface MascotContextValue {
  visible: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const MascotContext = createContext<MascotContextValue | null>(null);

export const MascotProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [visible, setVisible] = useState(true);

  const open = useCallback(() => setVisible(true), []);
  const close = useCallback(() => setVisible(false), []);
  const toggle = useCallback(() => setVisible((v) => !v), []);

  return (
    <MascotContext.Provider value={{ visible, open, close, toggle }}>
      {children}
    </MascotContext.Provider>
  );
};

export const useMascot = (): MascotContextValue => {
  const ctx = useContext(MascotContext);
  if (!ctx) throw new Error('useMascot must be used within MascotProvider');
  return ctx;
};
